import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=523a8e54&scoped=true&"
import script from "./SearchView.vue?vue&type=script&lang=js&"
export * from "./SearchView.vue?vue&type=script&lang=js&"
import style0 from "./SearchView.vue?vue&type=style&index=0&id=523a8e54&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a8e54",
  null
  
)

export default component.exports